import { render, staticRenderFns } from "./ListColumn.vue?vue&type=template&id=053f82f2&scoped=true"
import script from "./ListColumn.vue?vue&type=script&lang=js"
export * from "./ListColumn.vue?vue&type=script&lang=js"
import style0 from "./ListColumn.vue?vue&type=style&index=0&id=053f82f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f82f2",
  null
  
)

export default component.exports